module.exports = "<p>\n  item-detail works!\n</p>\n"